import { render, staticRenderFns } from "./BrandIntroTemplate.vue?vue&type=template&id=1b65d5d3"
import script from "./BrandIntroTemplate.vue?vue&type=script&lang=js"
export * from "./BrandIntroTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports